export const projectsData = [
  {
    id: 1,
    title: "Crypto",
    date: "April 2023",
    languages: ["React", "Redux", "SASS", "Rest API"],
    infos:
      "An application that tracks the changes in cryptocurrency market. With access to up-to-date market data, users can stay informed and make more informed decisions about when to buy or sell different cryptocurrencies.",
    img: "./assets/img/project1.png",
    link: "https://cryp-watch.netlify.app",
    code: "https://github.com/otfigo87/Crypto-Watch",
  },
  {
    id: 2,
    title: "Connectify",
    date: "May 2023",
    languages: ["React", "Redux", "NodeJs", "MongoDB"],
    infos:
      "Introducing the first version of my new social media app, built using the MERN stack. This app is designed to bring people together and make it easy to connect and share with friends and family...",
    img: "./assets/img/project2.png",
    link: "https://connectify-app.herokuapp.com/",
    code: "https://github.com/otfigo87/SocialMedia-Connectify-MERN",
  },
  {
    id: 3,
    title: "Lyon Béton",
    date: "July 2022",
    languages: ["React", "Framer-motion", "Styled-Components"],
    infos:
      "Webapp to showcase the stunning portfolio of a professional photographer. With high-quality images and easy navigation, potential clients can browse the photographer's work and learn about their services.",
    img: "./assets/img/project3.png",
    link: "https://github.com/otfigo87",
    code: "https://github.com/otfigo87/photography",
  },
  {
    id: 4,
    title: "Nations",
    date: "February 2023",
    languages: ["HTML", "CSS", "JavaScript"],
    infos:
      "Think you know all flags? Try this Flags Quiz Game, Test your knowledge on geography and compare your score to others, Guess the flags of 197 countries from Afghanistan to Zimbabwe.",
    img: "./assets/img/project4.jpg",
    link: "https://otfigo87.github.io/mod1-flag-quiz-game/",
    code: "https://github.com/otfigo87/mod1-flag-quiz-game",
  },
  {
    id: 5,
    title: "SEI Café",
    date: "Mars 2023",
    languages: ["React", "Express", "NodeJs", "MongoDB"],
    infos:
      "Online store for a delightful café experience. Sign up, browse, and order with ease for a taste of exquisite drinks and delicious food, all within a user-friendly interface.",
    img: "./assets/img/project5.png",
    link: "https://sei-cafe.herokuapp.com/",
    code: "https://github.com/otfigo87/SEI_cafe",
  },
];
